import { CancelledOrdersMainContainer } from '@/modules/CancelledOrders';

const CancelledOrders = (): JSX.Element => <CancelledOrdersMainContainer />;

export default CancelledOrders;
